module.exports = __webpack_public_path__ + "img/TrophyOne.79b6071c.svg";